import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Form, Input, Button, Upload, Spin, message, Row, Col } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import getAllAdmin from "../../../hooks/getAllAdmin";
import { toast } from "react-toastify";

const GeneralSettings = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({});
  const [logoinput, setLogoInput] = useState(null);
  const [iconinput, setIconInput] = useState(null);
  const user = JSON.parse(localStorage.getItem("admin"));

  useEffect(() => {
    const getGeneralSettings = async () => {
      const res = await getAllAdmin("admin/getfulldetails");

      if (res.status_code === 200) {
        setSettings(res.data[0]);
        form.setFieldsValue(res.data[0]);
      }
      setLoading(false);
    };

    getGeneralSettings();
  }, [form]);

  const onFinish = async (values) => {
    setLoading(true);
    const formData = new FormData();

    Object.entries(values).forEach(([key, val]) => {
      formData.append(key, val);
    });

    if (logoinput) formData.append("logo", logoinput);
    if (iconinput) formData.append("favicon", iconinput);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_APIURL}/admin/updategeneraldetails`,
        {
          method: "PATCH",
          body: formData,
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      const response = await res.json();
      if (response.status_code === 200) {
        toast.success(response.message);
        window.location.reload();
      } else {
        toast.error(response.message || response.err);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
    setLoading(false);
  };


  return (
    <>
      <Helmet>
        <title>{t("Admin")} - {t("Settings")}</title>
      </Helmet>
      <div className="mt-2 mb-16">
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          className="max-w-4xl mx-auto bg-white p-6 rounded border shadow-sm"
        >
          <h2 className="text-lg md:text-xl font-semibold mb-4">
            {t("Settings")}
          </h2>

          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={t("Site_name")}
                name="name"
                rules={[{ required: true, message: t("Required") }]}
              >
                <Input placeholder={t("Site_name")} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label={t("Logo")}>
                <Upload
                  beforeUpload={(file) => {
                    setLogoInput(file);
                    return false;
                  }}
                  showUploadList={false}
                >
                  <Button icon={<UploadOutlined />}>{t("Upload Logo")}</Button>
                </Upload>
                {logoinput ? (
                  <p className="text-green-500 text-xs mt-1">{t("Site_logo_preview")}</p>
                ) : (
                  settings?.logo && (
                    <img src={settings.logo} alt="Logo" className="w-20 h-20 mt-2 object-contain" />
                  )
                )}
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label={t("Favicon")}>
                <Upload
                  beforeUpload={(file) => {
                    setIconInput(file);
                    return false;
                  }}
                  showUploadList={false}
                >
                  <Button icon={<UploadOutlined />}>{t("Upload Icon")}</Button>
                </Upload>
                {iconinput ? (
                  <p className="text-green-500 text-xs mt-1">{t("Site_icon_preview")}</p>
                ) : (
                  settings?.favicon && (
                    <img src={settings.favicon} alt="Icon" className="w-20 h-20 mt-2 object-contain" />
                  )
                )}
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label={t("l_phone")} name="contact_no">
                <Input type="number" placeholder={t("l_phone")} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label={t("Alternate_Contact_no")} name="alternate_contact_no">
                <Input type="number" placeholder={t("Alternate_Contact_no")} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label={t("form_email")} name="email">
                <Input type="email" placeholder={t("form_email")} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label={t("Alternate_Email")} name="alternate_email">
                <Input type="email" placeholder={t("Alternate_Email")} />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item label={t("Address")} name="address">
                <Input placeholder={t("Address")} />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item label={t("Description")} name="description">
                <Input.TextArea rows={3} placeholder={t("Description")} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Facebook URL" name="facebook_url">
                <Input type="url" placeholder="https://" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Instagram URL" name="instagram_url">
                <Input type="url" placeholder="https://" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Twitter URL" name="twitter_url">
                <Input type="url" placeholder="https://" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Youtube URL" name="youtube_url">
                <Input type="url" placeholder="https://" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Moyasar Publishable Key" name="moyasar_publishable_key">
                <Input placeholder="Moyasar Publishable Key" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Moyasar Secret Key" name="moyasar_secret_key">
                <Input placeholder="Moyasar Secret Key" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <button type="submit" className="btn btn-primary text-white" disabled={loading}>
              {t("Save")}
            </button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default GeneralSettings;
